import { UseCampaignsHasRecentTriggeredAlertsState } from 'modules/campaigns/lib/hooks';
import { GraphQLCampaign } from '../domainTypes';
import { useCampaignTriggeredAlertsMap } from '../hooks/useCampaignTriggeredAlertsMap';
import { GraphQLCampaignSubfolder } from '../types';
import { CampaignFolderRow } from './CampaignFolderRow';
import { CampaignRow } from './CampaignRow';
import { SavedAlertsByMedium } from '../../campaigns/alerts/types';
import { usePreviewThumbnails } from 'modules/templateIndex/hooks';

export const CampaignFoldersTableRows = ({
  folders,
  campaigns,
  userInfoLookup,
  campaignTriggeredAlerts,
  projectAlerts,
}: {
  folders: GraphQLCampaignSubfolder[];
  campaigns: GraphQLCampaign[];
  campaignTriggeredAlerts?: UseCampaignsHasRecentTriggeredAlertsState['campaignTriggeredAlerts'];
  userInfoLookup: any;
  projectAlerts: SavedAlertsByMedium;
}) => {
  const campaignTriggeredAlertsMap = useCampaignTriggeredAlertsMap(campaignTriggeredAlerts);
  const templateIds = campaigns.map((cp) => cp.templateId);
  const previewThumbails = usePreviewThumbnails(templateIds);

  return (
    <>
      {folders.map((folder) => (
        <CampaignFolderRow key={`folder-${folder.id}`} folder={folder} />
      ))}
      {campaigns.map((campaign) => (
        <CampaignRow
          key={`campaign-${campaign.id}`}
          campaign={campaign}
          previewThumbnail={previewThumbails[campaign.templateId]}
          userInfoLookup={userInfoLookup}
          hasRecentTriggeredAlerts={campaignTriggeredAlertsMap?.[campaign.id]?.hasRecentAlerts}
          projectAlerts={projectAlerts}
        />
      ))}
    </>
  );
};
